var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSuccess = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6417,
    cy: 57.6417,
    r: 57.6417,
    fill: "#54C742"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8326 71.0718L34.7493 59.0454C34.0987 58.3964 33.2154 58.0317 32.2943 58.0317C31.3732 58.0317 30.4899 58.3964 29.8394 59.0454C28.4813 60.397 28.4813 62.5805 29.8394 63.9322L44.395 78.4194C45.7531 79.771 47.9469 79.771 49.305 78.4194L86.1469 41.7509C87.505 40.3992 87.505 38.2157 86.1469 36.864C85.4963 36.2151 84.6131 35.8503 83.692 35.8503C82.7708 35.8503 81.8876 36.2151 81.237 36.864L46.8326 71.0718Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-success.3047e6e3129ae2835bf7c8da701e836f.svg";